var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web_header"},[_c('div',{staticClass:"language",style:(_vm.style),on:{"click":_vm.handleClickLang}},[_vm._v(" "+_vm._s(_vm.language)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }